import { request } from '@umijs/max';

import { GetTranslationsResponse } from './types';

export async function getTranslations(): Promise<GetTranslationsResponse> {
  return request('translations', {
    method: 'GET',
  });
}
